export const enum PoliciesEnumType {
  PRIVACY_POLICY = 'Privacy Policy',
  TERMS_OF_SERVICES = 'Terms of Services',
  TERMS_OF_USE = 'Terms of Use',
}

export const PRIVACY_HEADER = '© UNICORNFORMS, INC. ONLINE PRIVACY POLICY';
export const TERMS_OF_USE_HEADER = 'TERMS OF USE';